export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/video_editing.425733f.svg";